import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';
import sortAndCombineDayOfTimeblocks from './sortAndCombineDayOfTimeblocks';
import buildSbmParams from './buildSbmParams';
import moment from 'moment-timezone';
import getCynoMidnightTime from './getCynoMidnightTime';

const sortExceptionTimesinCynoTimeByCynoDates = (exceptionTimeBlockInCynoTime, date, operationType, exceptionsInCynoTime, availabilityDaysInCynoTime, SBMId) => {
    let sbmParamsObjectSet = {};
    let exceptionToDelete;

    exceptionTimeBlockInCynoTime.map((dayOfBlocks, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (dayOfBlocks.length > 0) {
            if (dayIsNowDayBefore(i)) {
                const pastDate = moment(moment.utc(date)).add(-1, 'd').format("YYYY-MM-DD");
                const pastDay = moment(pastDate).day();

                if (exceptionsInCynoTime[pastDate]) {
                    exceptionsInCynoTime[pastDate].push(...dayOfBlocks);
                }
                else if (!exceptionsInCynoTime[pastDate] && (!availabilityDaysInCynoTime[pastDay] || typeof availabilityDaysInCynoTime[pastDay][0] === 'string')) {
                    exceptionsInCynoTime[pastDate] = [...dayOfBlocks];
                }
                else if (!exceptionsInCynoTime[pastDate] && typeof availabilityDaysInCynoTime[pastDay][0] !== 'string') {
                    exceptionsInCynoTime[pastDate] = [...availabilityDaysInCynoTime[pastDay], ...dayOfBlocks];
                };

                const combinedDay = sortAndCombineDayOfTimeblocks(exceptionsInCynoTime[pastDate]);
                exceptionsInCynoTime[pastDate] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, pastDate, operationType, SBMId);
                sbmParamsObjectSet[pastDate] = sbmParamsObject;

            }
            if (dayIsSameDay(i)) {
                const day = moment(date).day();
                const nextDate = moment(moment.utc(date)).add(1, 'd').format("YYYY-MM-DD");

                if (exceptionsInCynoTime[date]) {
                    exceptionsInCynoTime[date].push(...dayOfBlocks);
                }
                else if (!exceptionsInCynoTime[date] && (!availabilityDaysInCynoTime[day] || typeof availabilityDaysInCynoTime[day][0] === 'string')) {
                    exceptionsInCynoTime[date] = [...dayOfBlocks];
                }
                else if (!exceptionsInCynoTime[date] && typeof availabilityDaysInCynoTime[day][0] !== 'string') {
                    exceptionsInCynoTime[date] = [...availabilityDaysInCynoTime[day], ...dayOfBlocks];
                };

                if (!exceptionTimeBlockInCynoTime[2].length && exceptionsInCynoTime[nextDate]) {
                    const nextDate = moment(moment.utc(date)).add(1, 'd').format("YYYY-MM-DD");
                    const cynoMidnightTime = getCynoMidnightTime();
                    const nextDayFirstBlockStart = exceptionsInCynoTime[nextDate][0][0].replace(":",'.');
                    const nextDayFirstBlockEnd = exceptionsInCynoTime[nextDate][0][1].replace(":",'.');

                    if (nextDayFirstBlockStart < cynoMidnightTime && nextDayFirstBlockEnd <= cynoMidnightTime) {
                        exceptionsInCynoTime[nextDate].shift();
                        if (exceptionsInCynoTime[nextDate].length) {
                            const nextDaySbmParamsObject = buildSbmParams(exceptionsInCynoTime[nextDate], nextDate, operationType, SBMId);
                            sbmParamsObjectSet[nextDate] = nextDaySbmParamsObject;
                        } else {
                            exceptionToDelete = [nextDate];
                        }
                    } else if (nextDayFirstBlockStart < cynoMidnightTime && nextDayFirstBlockEnd > cynoMidnightTime) {
                        exceptionsInCynoTime[nextDate][0][0] = cynoMidnightTime.replace(".",':');
                        const nextDaySbmParamsObject = buildSbmParams(exceptionsInCynoTime[nextDate], nextDate, operationType, SBMId);
                        sbmParamsObjectSet[nextDate] = nextDaySbmParamsObject;
                    }
                }

                const combinedDay = sortAndCombineDayOfTimeblocks(exceptionsInCynoTime[date]);
                exceptionsInCynoTime[date] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, date, operationType, SBMId);
                sbmParamsObjectSet[date] = sbmParamsObject;

            }
            if (dayIsNowDayAfter(i)) {
                const nextDate = moment(moment.utc(date)).add(1, 'd').format("YYYY-MM-DD");
                const nextDay = moment(nextDate).day();

                if (exceptionsInCynoTime[nextDate]) {
                    exceptionsInCynoTime[nextDate].push(...dayOfBlocks);
                }
                else if (!exceptionsInCynoTime[nextDate] && (!availabilityDaysInCynoTime[nextDay] || typeof availabilityDaysInCynoTime[nextDay][0] === 'string')) {
                    exceptionsInCynoTime[nextDate] = [...dayOfBlocks];
                }
                else if (!exceptionsInCynoTime[nextDate] && typeof availabilityDaysInCynoTime[nextDay][0] !== 'string') {
                    exceptionsInCynoTime[nextDate] = [...availabilityDaysInCynoTime[nextDay], ...dayOfBlocks];
                };

                const combinedDay = sortAndCombineDayOfTimeblocks(exceptionsInCynoTime[nextDate]);
                exceptionsInCynoTime[nextDate] = combinedDay;
                const sbmParamsObject = buildSbmParams(combinedDay, nextDate, operationType, SBMId);
                sbmParamsObjectSet[nextDate] = sbmParamsObject;

            };
        };
    });
    return [sbmParamsObjectSet, exceptionsInCynoTime, exceptionToDelete];
};

export default sortExceptionTimesinCynoTimeByCynoDates;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/sortExceptionTimesinCynoTimeByCynoDates.js